export default function Parenthetical ({ children }) {
  return (
    <div className='my-5'>
      <div className='uppercase text-center'>({children})</div>
    </div>
  )
}
